import { combineReducers } from 'redux';

import userSearch from './user-search';

export default combineReducers({
  userSearch
});
